import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';
import { Auth0Provider } from '@auth0/auth0-react';
import Navigation from './components/Navigation.jsx';
import MainApp from './components/MainApp.jsx';
import AuthCallback from './components/AuthCallback.jsx';
import Settings from './components/Settings.jsx';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  // Handle PWA redirect URI properly
  const getRedirectUri = () => {
    // Always use the callback route for proper OAuth handling
    return `${window.location.origin}/callback`;
  };

  return (
    <Auth0Provider
      domain="dev-k7zvsxvc6h2imbuj.us.auth0.com"
      clientId="USDiFlPQpUvVXSRvGqPChSjXh9B6s60b"
      authorizationParams={{
        redirect_uri: getRedirectUri(),
        connection: 'Strava' // Go directly to Strava
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            <Route path="/callback" element={<AuthCallback />} />
            <Route path="/*" element={<MainApp />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Auth0Provider>
  );
}

export default App;
